// Shared guest-passenger form constants. Mirrors the mobile guest passenger form
// (app-customer src/components/guest-passenger-form/GuestPassengerFormFields.tsx).
// Consumed by AddEditGuestModal and the client booking PassengerPanel ("Who is this booking for?").
export const TITLE_OPTIONS = ["Mr.", "Mrs.", "Ms.", "Miss", "Dr.", "Prof.", "Sir."];

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
